import {Expose, Type} from 'class-transformer'
import {AlertCircle} from 'react-feather'

import {Place} from './Place'
import {Sku} from './Sku'

export class Replenishment {
  static type = 'replenishment'
  static typeDisplay = 'Replenishment'
  static icon = AlertCircle

  type = Replenishment.type
  typeDisplay = Replenishment.typeDisplay
  icon = Replenishment.icon

  guid: string = ''

  @Expose({name: 'num_to_pick'})
  numToPick: number = 0

  @Expose({name: 'total_stored'})
  totalStored: number = 0

  @Type(() => Place)
  place?: Place

  @Type(() => Sku)
  sku?: Sku
}
